import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';

import ChipContext, { ChipVariant } from './context/ChipContext';

interface Props extends HTMLAttributes<HTMLDivElement>{
    variant?: ChipVariant;
}

function ChipContainer({ children, variant = 'fill', ...rest }:Props) {
    return (
        <ChipContext value={{ variant }}>
            <Container variant={variant}
                aria-label='chip-container'
                {...rest} >
                {children}
            </Container>
        </ChipContext>
    );
}

const Container = styled.div<{variant: ChipVariant}>`
    display: flex;
    column-gap: ${({ variant }) => (variant === 'outline' ? 8 : 12)}px;
`;

export default ChipContainer;
